import React, { useState, useCallback, useEffect, useRef } from "react";
import CreatableSelect from "react-select/creatable";
import Cropper from "react-easy-crop";
import "react-easy-crop/react-easy-crop.css";
import {
  isValidPhoneNumber,
  showToast,
  formatReferralOrgOptions
} from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import {
  Country,
  State,
  Organisation_Lead,
  Upfront_type,
  trail_type,
  time_period,
  discount_type
} from "../../utils/data/data";
import "../../assets/scss/refferalpartner.scss";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import "./imgcrop.scss";
import {
  EMAIL_REGEX_STRICT,
  NAME_REGEX,
  showToastType,
  USERNAME_REGEX
} from "../../utils/constants/appConstants";
import {
  createReffPartner,
  duplicateReffPartner,
  buttonName,
  alertActions,
  processing,
  commonText
} from "../../locales/en";
import {
  getBankAccountDataURL,
  getEditReferralUserURL,
  getreferralImageIdURL,
  getReferralOrgDataURL,
  getReferralTableURL,
  getUserSalesLeadPersonUrl
} from "../../utils/constants/apiEndPoints";
import privateAxios from "../../utils/axiosPrivate";
import { allowedLabels } from "../../utils/getDropdownOptions";
import { useSelector } from "react-redux";
import { isBooleanField } from "../../utils/constants/formDataFields";
import { REFERRAL_PARTNERS } from "../../route/paths";
import { generateReferralUrls } from "../../utils/referralUtils";

export default function DuplicatePartner() {
  const { profile } = useSelector((state) => state.userManagement);
  const { id } = useParams();
  const [salesLeadStatus, setSalesLeadStatus] = useState([]);
  const [optionsData, setOptionsData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const afterInitialRender = useRef(false);
  const [isPartnerTypeLocked, setIsPartnerTypeLocked] = useState(false);
  const [loading, setLoading] = useState({
    createBtn: false
  });
  // FOR IMAGE CROPPER
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showCroppedImage, setShowCroppedImage] = useState(null);
  // FOR IMAGE CROPPER

  const [useOrganisationBankAccount, setUseOrganisationBankAccount] =
    useState(false);
  const initialReferralUser = {
    name: "",
    email: "",
    phone: "",
    organisationName: "",
    organisationLead: true,
    code: "",
    state: "",
    signupPageUrl: "",
    wpSignupPageUrl: "",
    sendEmailOnClientFunding: true,
    partnerType: createReffPartner?.defaultValues?.partnerType,
    salesPersonLeadId: "",
    displayOnWpListingPage: true,
    organisationWebsite: "",
    partnerListingDescription: "",
    bankAccountNumber: "",
    orgBankAccountDisabled: false,
    upfront: "",
    upfrontType: createReffPartner?.defaultValues?.upfrontType,
    trail: "",
    trailType: createReffPartner?.defaultValues?.trailType,
    upfrontClientDiscount: "",
    upfrontClientDiscountType:
      createReffPartner?.defaultValues?.upfrontClientDiscountType,
    ongoingClientDiscount: "",
    trailPeriod: "",
    shortDescription: "",
    ongoingClientTrailPeriod: "",
    documentFilePath: ""
  };
  const [referralUser, setReferralUser] = useState(initialReferralUser);

  const fetchSalesLeadData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getUserSalesLeadPersonUrl);
      setSalesLeadStatus(response.data.data);
    } catch (error) {
      showToast(
        error?.response?.data?.message || error.message,
        showToastType?.error
      );
    }
  }, [privateAxios]);

  const fetchReferralImageData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getreferralImageIdURL(id), {
        responseType: "blob"
      });
      const imageUrl = URL.createObjectURL(response.data);

      setShowCroppedImage(imageUrl);
    } catch {
      //handle error
    }
  }, [privateAxios, id]);

  const fetchReferralOrgData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getReferralOrgDataURL);
      const { data } = response.data;
      const formattedOptions = formatReferralOrgOptions(data, allowedLabels);
      setOptionsData(formattedOptions);
    } catch (error) {
      showToast(
        error?.response?.data?.message || error.message,
        showToastType?.error
      );
    }
  }, [privateAxios]);

  const handleStateChange = (e) => {
    const value = e.target.value;
    setSelectedCountry(value);
    if (value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        selectedCountry: ""
      }));
    }
  };

  // Refs for each input field
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const nameRef = useRef(null);
  const countryRef = useRef(null);
  const codeRef = useRef(null);
  const bankAccountRef = useRef(null);
  const websiteRef = useRef(null);
  const upfrontRef = useRef(null);
  const trailRef = useRef(null);
  const upfrontDiscountRef = useRef(null);
  const ongoingDiscountRef = useRef(null);
  const organisationNameRef = useRef(null);
  const trailPeriodRef = useRef(null);
  const ongoingTrailPeriodRef = useRef(null);

  const refsMap = {
    phone: phoneRef,
    email: emailRef,
    name: nameRef,
    selectedCountry: countryRef,
    code: codeRef,
    bankAccountNumber: bankAccountRef,
    organisationWebsite: websiteRef,
    upfront: upfrontRef,
    trail: trailRef,
    upfrontClientDiscount: upfrontDiscountRef,
    ongoingClientDiscount: ongoingDiscountRef,
    organisationName: organisationNameRef,
    trailPeriod: trailPeriodRef,
    ongoingClientTrailPeriod: ongoingTrailPeriodRef
  };

  const {
    name,
    email,
    phone,
    organisationName,
    organisationLead,
    state,
    code,
    signupPageUrl,
    wpSignupPageUrl,
    sendEmailOnClientFunding,
    partnerType,
    salesPersonLeadId,
    displayOnWpListingPage,
    organisationWebsite,
    bankAccountNumber,
    orgBankAccountDisabled,
    partnerListingDescription,
    upfront,
    upfrontType,
    trail,
    trailType,
    upfrontClientDiscount,
    upfrontClientDiscountType,
    ongoingClientDiscount,
    trailPeriod,
    shortDescription,
    ongoingClientTrailPeriod,
    documentFilePath
  } = referralUser;

  const onReferralCodeBlur = () => {
    const { code } = referralUser;

    const urls = generateReferralUrls(code);

    setReferralUser((prev) => ({
      ...prev,
      ...urls
    }));
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;

    if (isBooleanField(name)) {
      const booleanValue = value === commonText?.yes;

      setReferralUser((prevState) => {
        const updatedState = {
          ...prevState,
          [name]: booleanValue
        };

        if (name === "organisationLead") {
          updatedState.bankAccountNumber = "";
          updatedState.orgBankAccountDisabled = true;
        }

        return updatedState;
      });
    } else {
      setReferralUser((prevState) => ({
        ...prevState,
        [name]: value
      }));
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const validateEmails = (emailString) => {
    const emailArray = emailString.split(",").map((email) => email.trim());
    const emailRegex = EMAIL_REGEX_STRICT;

    // Check if each email is valid
    for (const email of emailArray) {
      if (!emailRegex.test(email)) {
        return false;
      }
    }
    return true;
  };

  const validate = () => {
    const tempErrors = {};
    if (!phone) {
      tempErrors.phone = createReffPartner?.errmsg.item1;
    } else if (!isValidPhoneNumber(phone)) {
      tempErrors.phone = createReffPartner?.errmsg.item2;
    }
    if (!email) {
      tempErrors.email = createReffPartner?.errmsg.item3;
    } else if (!validateEmails(email)) {
      tempErrors.email = createReffPartner?.errmsg.item33;
    }
    if (!name) {
      tempErrors.name = createReffPartner?.errmsg.item4;
    } else if (!NAME_REGEX.test(name)) {
      tempErrors.name = createReffPartner?.errmsg.item5;
    }

    if (!selectedCountry) {
      tempErrors.selectedCountry = createReffPartner?.errmsg.item6;
    }

    if (!code) {
      tempErrors.code = createReffPartner?.errmsg.item7;
    } else if (!USERNAME_REGEX.test(code)) {
      tempErrors.code = createReffPartner?.errmsg.item23;
    }

    if (upfront == null || upfront === "") {
      tempErrors.upfront = createReffPartner?.errmsg.item12;
    }
    if (trail == null || trail === "") {
      tempErrors.trail = createReffPartner?.errmsg.item13;
    }
    if (upfrontClientDiscount == null || upfrontClientDiscount === "") {
      tempErrors.upfrontClientDiscount = createReffPartner?.errmsg.item14;
    }
    if (ongoingClientDiscount == null || ongoingClientDiscount === "") {
      tempErrors.ongoingClientDiscount = createReffPartner?.errmsg.item15;
    }
    if (!organisationName) {
      tempErrors.organisationName = createReffPartner?.errmsg.item16;
    }
    if (!trailPeriod) {
      tempErrors.trailPeriod = createReffPartner?.errmsg.item17;
    }
    if (!ongoingClientTrailPeriod) {
      tempErrors.ongoingClientTrailPeriod = createReffPartner?.errmsg.item17;
    }

    if (Object.keys(tempErrors).length > 0) {
      const firstErrorField = Object.keys(tempErrors)[0];
      refsMap[firstErrorField].current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  // forImage cropper

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setCroppedImage(null);
      };
      reader.readAsDataURL(file);
    }
  };

  const getCroppedImg = async (imageSrc, crop, croppedAreaPixels) => {
    const image = new Image();
    image.src = imageSrc;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x * scaleX,
      croppedAreaPixels.y * scaleY,
      croppedAreaPixels.width * scaleX,
      croppedAreaPixels.height * scaleY,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error(createReffPartner?.errmsg.item18));
          return;
        }
        blob.name = "cropped.jpeg";
        resolve(blob);
      }, "image/jpeg");
    });
  };

  const handleCropClick = async () => {
    try {
      getCroppedImg(imageSrc, crop, croppedAreaPixels).then((croppedImg) => {
        const fileUrl = window.URL.createObjectURL(croppedImg);
        setCroppedImage(croppedImg);
        setShowCroppedImage(fileUrl);
      });
    } catch {
      // handle catch here;
    }
  };

  const duplicateReferralUser = useCallback(
    async (id) => {
      try {
        const response = await privateAxios.get(getEditReferralUserURL(id));
        const data = response.data.data;
        setSelectedCountry(data.country || "");
        setReferralUser({
          ...data,
          email: "",
          phone: "",
          signupPageUrl: "",
          wpSignupPageUrl: "",
          upfront: data.upfrontDiscountAmount ?? "0",
          upfrontType: data.upfrontDiscountType || "",
          trail: data.trailDiscountAmount ?? "0",
          trailType: data.trailDiscountType || "",
          upfrontClientDiscount: data.upfrontClientDiscountAmount ?? "0",
          upfrontClientDiscountType: data.upfrontClientDiscountType || "",
          ongoingClientDiscount: data.clientDiscountAmount ?? "0",
          trailPeriod: data.trailDiscountPeriodMonths || "",
          ongoingClientTrailPeriod: data.clientDiscountPeriodMonths || "",
          salesPersonLeadId: data.salesPersonLeadId || "",
          documentFilePath: data.documentFilePath || "",
          shortDescription: data.organisationShortDescription || ""
        });
      } catch {
        // handle catch here;
      }
    },
    [privateAxios]
  );

  useEffect(() => {
    if (initialRender.current) {
      if (id) {
        duplicateReferralUser(id);
      }
      fetchReferralImageData();
      fetchReferralOrgData();
      fetchSalesLeadData();
      initialRender.current = false;
    } else {
      if (afterInitialRender.current && id) {
        duplicateReferralUser(id);
      }
      afterInitialRender.current = true;
    }
  }, [
    id,
    duplicateReferralUser,
    fetchSalesLeadData,
    fetchReferralImageData,
    fetchReferralOrgData
  ]);

  // for org bank account fetch
  const getBankAccountData = async (newValue) => {
    try {
      const sendBankData = {
        organisationName,
        organisationLead,
        useOrganisationBankAccount: newValue
      };

      const response = await privateAxios.post(
        getBankAccountDataURL,
        sendBankData
      );

      const bankData = response.data.data;

      if (bankData && Object.keys(bankData).length > 0) {
        setUseOrganisationBankAccount(newValue);
        setReferralUser((prev) => ({
          ...prev,
          bankAccountNumber: bankData.bankAccountNumber || ""
        }));
      } else {
        setUseOrganisationBankAccount(false);
        setReferralUser((prev) => ({
          ...prev,
          bankAccountNumber: ""
        }));
      }

      if (bankData && Object.keys(bankData).length === 0) {
        showToast(createReffPartner?.errmsg.item19, showToastType?.error);
      }
    } catch {
      setUseOrganisationBankAccount(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;
    getBankAccountData(newValue);
  };

  // for submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading((prev) => ({ ...prev, createBtn: true }));

      const formDataToSend = new FormData();

      const userData = {
        email,
        contactNumber: phone,
        country: selectedCountry,
        fullName: name,
        contactPerson: name,
        referralCode: code,
        state,
        organisationLead,
        organisationName: referralUser.organisationName,
        signupPageUrl,
        wpSignupPageUrl,
        sendEmailOnClientFunding,
        partnerType,
        salesPersonLeadId: parseInt(salesPersonLeadId, 10),
        displayOnWpListingPage,
        organisationWebsite,
        bankAccountNumber,
        partnerListingDescription,
        upfrontDiscountAmount: upfront,
        upfrontDiscountType: upfrontType,
        trailDiscountAmount: trail,
        trailDiscountType: trailType,
        upfrontClientDiscountAmount: upfrontClientDiscount,
        upfrontClientDiscountType: upfrontClientDiscountType,
        clientDiscountAmount: ongoingClientDiscount,
        trailDiscountPeriodMonths: trailPeriod,
        clientDiscountPeriodMonths: ongoingClientTrailPeriod,
        organisationShortDescription: shortDescription,
        createdBy: profile?.id,
        ...(selectedFile ? {} : { documentFilePath })
      };

      const userDataBlob = new Blob([JSON.stringify(userData)], {
        type: "application/json"
      });
      formDataToSend.append("referralPartnerDto", userDataBlob);

      if (croppedImage && selectedFile) {
        formDataToSend.append(
          "referralPartnerImage",
          croppedImage,
          "cropped-img.jpeg"
        );
      }

      const config = {
        method: "post",
        url: getReferralTableURL,
        data: formDataToSend,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const response = await privateAxios(config);

      showToast(response.data.message, showToastType.success);

      navigate(REFERRAL_PARTNERS);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errors = error.response.data.errors;
        if (Array.isArray(errors)) {
          errors.forEach((err) => showToast(err, showToastType?.error));
        } else if (typeof errors === "object") {
          Object.values(errors).forEach((err) =>
            showToast(err, showToastType?.error)
          );
        } else {
          showToast(errors, showToastType?.error);
        }
      } else if (error.response && error.response.status === 500) {
        const errors = error.response.data.errors;

        if (
          Array.isArray(errors) &&
          errors.some((err) => err.includes("Invalid email"))
        ) {
          showToast(duplicateReffPartner?.errMsg.item2, showToastType?.error);
        } else {
          const errorMessage = error.response.data.message;
          showToast(errorMessage, showToastType?.error);
        }
      } else {
        showToast(error.message, showToastType?.error);
      }
    } finally {
      setLoading((prev) => ({ ...prev, createBtn: false }));
    }
  };

  const handleCancel = () => {
    setReferralUser({
      name: "",
      email: "",
      phone: "",
      organisationName: "",
      state: "",
      organisationLead: true,
      code: "",
      signupPageUrl: "",
      wpSignupPageUrl: "",
      sendEmailOnClientFunding: false,
      partnerType: "",
      salesPersonLeadId: "",
      displayOnWpListingPage: false,
      organisationWebsite: "",
      bankAccountNumber: "",
      partnerListingDescription: "",
      upfront: "",
      upfrontType: "",
      trail: "",
      trailType: "",
      upfrontClientDiscount: "",
      upfrontClientDiscountType: "",
      ongoingClientDiscount: "",
      trailPeriod: "",
      ongoingClientTrailPeriod: "",
      shortDescription: "",
      image: ""
    });
    setErrors({});
    navigate(REFERRAL_PARTNERS);
  };

  // Find the selected option for react-select
  const selectedOption = optionsData
    .flatMap((option) => (option.options ? option.options : [option]))
    .find((option) => option.value === organisationName);

  // Handle select change
  const handleSelectChange = (option) => {
    if (!option) {
      setReferralUser((prevState) => ({
        ...prevState,
        organisationName: "",
        partnerType: prevState.partnerType
      }));
      setIsPartnerTypeLocked(false);
      return;
    }

    const groupName = optionsData.find(
      (group) =>
        group.options &&
        group.options.some((item) => item.value === option.value)
    )?.label;

    setReferralUser((prevState) => ({
      ...prevState,
      organisationName: option.value,
      partnerType: groupName || prevState.partnerType
    }));

    // Lock partnerType only if the organisationName matches a group label
    const isUnderGroup = !!groupName;
    setIsPartnerTypeLocked(isUnderGroup);

    // Remove the error message for organisationName if a value is selected
    if (option.value) {
      setErrors((prevErrors) => {
        const { ...otherErrors } = prevErrors;
        return otherErrors;
      });
    }
  };

  // Handle creating a new option
  const handleCreateOption = (inputValue) => {
    const updatedOptionsData = [
      ...optionsData,
      {
        value: inputValue,
        label: inputValue
      }
    ];

    setOptionsData(updatedOptionsData);

    setReferralUser((prevState) => ({
      ...prevState,
      organisationName: inputValue
    }));

    // Allow partnerType selection for newly created options
    setIsPartnerTypeLocked(false);
  };

  // Custom styles for react-select
  const customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: "14px",
      padding: "4px 12px"
    }),
    control: (provided) => ({
      ...provided,
      fontSize: "14px"
    })
  };

  return (
    <>
      <TablePagesTitle
        mainTitle={duplicateReffPartner.mainTitle}
        content={duplicateReffPartner.content}
      />
      <AccessPageAction
        subheading={duplicateReffPartner.mainTitle}
        allUserTitle={createReffPartner.subH2}
        alluser={REFERRAL_PARTNERS}
        createUserTitle={createReffPartner.content}
        createuser="/admin/referral-partners/create"
      />

      <div className="row ">
        <div className="col-md-12 sale-leade-form ps-3">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="referral">
                    {createReffPartner?.referralPerson}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={nameRef}
                    type="text"
                    placeholder="Referral Person"
                    id="name"
                    name="name"
                    onChange={onInputChange}
                    value={name}
                  />
                  {errors.name && (
                    <div className="text-danger small">{errors.name}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="email">{buttonName?.email}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={emailRef}
                    type="email"
                    placeholder="Email"
                    name="email"
                    id="email"
                    onChange={onInputChange}
                    value={email}
                  />
                  {errors.email && (
                    <div className="text-danger small">{errors.email}</div>
                  )}
                  <small className="my-1 d-block w-100">
                    {createReffPartner?.emailText}
                  </small>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="phone">{createReffPartner?.phone}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={phoneRef}
                    type="tel"
                    placeholder="Phone"
                    name="phone"
                    id="phone"
                    onChange={onInputChange}
                    value={phone}
                  />
                  {errors.phone && (
                    <div className="text-danger small d-block">
                      {errors.phone}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="country">{createReffPartner?.country}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    ref={countryRef}
                    name="country"
                    id="country"
                    value={selectedCountry}
                    onChange={handleStateChange}
                  >
                    {Country.map((data, index) => (
                      <option key={index} value={data.value}>
                        {data.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.selectedCountry && (
                    <div className="text-danger small d-block">
                      {errors.selectedCountry}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="state">{createReffPartner?.state}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  {selectedCountry === "AUS" ? (
                    <select
                      name="state"
                      id="state"
                      onChange={onInputChange}
                      value={state}
                    >
                      {State.map((data, index) => (
                        <option key={index} value={data.value}>
                          {data.state_name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      id="state"
                      onChange={onInputChange}
                      value={state}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="referralOrg">
                    {createReffPartner?.referralOrg}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <CreatableSelect
                    ref={organisationNameRef}
                    name="organisationName"
                    id="organisation"
                    options={optionsData}
                    onChange={handleSelectChange}
                    onCreateOption={handleCreateOption}
                    value={selectedOption}
                    isSearchable
                    isClearable
                    styles={customStyles}
                    placeholder={createReffPartner.selectOrg}
                  />
                  {errors.organisationName && (
                    <div className="text-danger small d-block">
                      {errors.organisationName}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="OrgLead">{createReffPartner?.OrgLead}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    name="organisationLead"
                    id="organisationLead"
                    onChange={onInputChange}
                    value={organisationLead ? commonText?.yes : commonText?.no}
                  >
                    {Organisation_Lead.map((data, index) => (
                      <option key={index} value={data.value}>
                        {data.lead_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="referralCode">
                    {createReffPartner?.referralCode}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={codeRef}
                    type="text"
                    placeholder="Referral Code"
                    name="code"
                    id="referralcode"
                    onChange={onInputChange}
                    onBlur={onReferralCodeBlur}
                    value={code}
                  />
                  {errors.code && (
                    <div className="text-danger small d-block">
                      {errors.code}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="partnerUrl">
                    {createReffPartner?.partnerUrl}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Sign-up URL"
                    name="signupPageUrl"
                    id="partner_url"
                    onChange={onInputChange}
                    value={signupPageUrl}
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="partnerSignupUrl">
                    {createReffPartner?.partnerSignupUrl}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text98"
                    placeholder="Partner Sign Up URL"
                    name="wpSignupPageUrl"
                    onChange={onInputChange}
                    value={wpSignupPageUrl}
                    readOnly
                  />
                  {code && (
                    <small className="text-success my-1">
                      {createReffPartner?.partnerSignupUrlText}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="customerFunded">
                    {createReffPartner?.customerFunded}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    name="sendEmailOnClientFunding"
                    id="customer_funded"
                    onChange={onInputChange}
                    value={
                      sendEmailOnClientFunding
                        ? commonText?.yes
                        : commonText?.no
                    }
                  >
                    {Organisation_Lead.map((data, index) => (
                      <option key={index} value={data.value}>
                        {data.lead_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="reffPartnerType">
                    {createReffPartner?.reffPartnerType}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    name="partnerType"
                    onChange={(e) =>
                      setReferralUser((prevState) => ({
                        ...prevState,
                        partnerType: e.target.value
                      }))
                    }
                    value={partnerType}
                    disabled={isPartnerTypeLocked}
                  >
                    {allowedLabels.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="bankAcc">{createReffPartner?.bankAcc}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={bankAccountRef}
                    type="text"
                    placeholder="Bank Account"
                    name="bankAccountNumber"
                    onChange={onInputChange}
                    value={bankAccountNumber}
                    disabled={
                      !!orgBankAccountDisabled === false &&
                      !!organisationLead === false
                    }
                  />
                </div>
                {orgBankAccountDisabled === true &&
                  orgBankAccountDisabled !== null && (
                    <div className="input-group orgbankaccount mt-2">
                      <input
                        type="checkbox"
                        name="useOrganisationBankAccount"
                        id="useOrganisationBankAccount"
                        checked={useOrganisationBankAccount}
                        onChange={handleCheckboxChange}
                        disabled={
                          !(
                            organisationName &&
                            organisationName.trim() !== "" &&
                            organisationLead === false
                          )
                        }
                      />
                      <label
                        htmlFor="useOrganisationBankAccount"
                        className="ps-1"
                      >
                        {createReffPartner?.bankAccText}
                      </label>
                    </div>
                  )}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="Referral">
                    {createReffPartner.reffsalesLead}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    id="salesPersonLeadId"
                    onChange={onInputChange}
                    value={salesPersonLeadId}
                    name="salesPersonLeadId"
                  >
                    <option value="">
                      {createReffPartner.selectSalesLead}
                    </option>
                    {salesLeadStatus
                      .filter((data) => !data.deletedAt)
                      .map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="showReffList">
                    {createReffPartner?.showReffList}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    onChange={onInputChange}
                    value={
                      displayOnWpListingPage ? commonText?.yes : commonText?.no
                    }
                    name="displayOnWpListingPage"
                  >
                    {Organisation_Lead.map((data, index) => (
                      <option key={index} value={data.value}>
                        {data.lead_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="reffListWebsite">
                    {createReffPartner?.reffListWebsite}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    ref={websiteRef}
                    type="text"
                    placeholder="Referral Listing Website"
                    name="organisationWebsite"
                    onChange={onInputChange}
                    value={organisationWebsite}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="reffListPage">
                    {createReffPartner?.reffListPage}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <textarea
                    placeholder="Referral Listing Page description"
                    onChange={onInputChange}
                    name="partnerListingDescription"
                    value={partnerListingDescription}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-12 my-3">
                <div className="input-title">
                  <label htmlFor="commAndDiscount">
                    {createReffPartner?.commAndDiscount}
                  </label>
                </div>
              </div>

              <div className="row mx-0 px-0 mb-2">
                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="upfront">
                          {createReffPartner?.upfront}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <input
                          ref={upfrontRef}
                          type="number"
                          min="0"
                          step="0.01"
                          name="upfront"
                          onChange={onInputChange}
                          value={upfront}
                        />
                        {errors.upfront && (
                          <div className="text-danger small d-block">
                            {errors.upfront}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-12">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="upfrontTpe">
                          {createReffPartner?.upfrontTpe}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <select
                          id="upfornt_type"
                          onChange={onInputChange}
                          value={upfrontType}
                          name="upfrontType"
                        >
                          {Upfront_type.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-0 px-0 mb-2">
                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="trail">
                          {createReffPartner?.trail}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <input
                          ref={trailRef}
                          type="number"
                          min="0"
                          step="0.01"
                          onChange={onInputChange}
                          value={trail}
                          name="trail"
                        />
                        {errors.trail && (
                          <div className="text-danger small d-block">
                            {errors.trail}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="trailType">
                          {createReffPartner?.trailType}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <select
                          onChange={onInputChange}
                          value={trailType}
                          name="trailType"
                        >
                          {trail_type.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-12">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="trailPeriod">
                          {createReffPartner?.trailPeriod}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <select
                          ref={trailPeriodRef}
                          onChange={onInputChange}
                          value={trailPeriod}
                          name="trailPeriod"
                        >
                          {time_period.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.time}
                            </option>
                          ))}
                        </select>
                        {errors.trailPeriod && (
                          <div className="text-danger small d-block">
                            {errors.trailPeriod}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-0 px-0 mb-2 ">
                <div className="col-xl-4 col-md-6 my-sm-2 mt-sm-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="upfrontClientDscount">
                          {createReffPartner?.upfrontClientDscount}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <input
                          ref={upfrontDiscountRef}
                          type="number"
                          min="0"
                          step="0.01"
                          name="upfrontClientDiscount"
                          onChange={onInputChange}
                          value={upfrontClientDiscount}
                        />
                        {errors.upfrontClientDiscount && (
                          <div className="text-danger small d-block">
                            {errors.upfrontClientDiscount}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-6 mt-2 mt-sm-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="upfrontClientDscountType">
                          {createReffPartner?.upfrontClientDscountType}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <select
                          onChange={onInputChange}
                          value={upfrontClientDiscountType}
                          name="upfrontClientDiscountType"
                        >
                          {discount_type.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-0 px-0 mb-2">
                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="ongoingClientDiscnt">
                          {createReffPartner?.ongoingClientDiscnt}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <input
                          ref={ongoingDiscountRef}
                          type="number"
                          min="0"
                          step="0.01"
                          onChange={onInputChange}
                          value={ongoingClientDiscount}
                          name="ongoingClientDiscount"
                        />
                        {errors.ongoingClientDiscount && (
                          <div className="text-danger small d-block">
                            {errors.ongoingClientDiscount}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row">
                    <div className="col-sm-12 d-flex justify-content-center justify-content-sm-end justify-content-xl-center">
                      <span>{createReffPartner?.feeText}</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-12 mb-2 mb-xl-0">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-title">
                        <label htmlFor="trailPeriod">
                          {createReffPartner?.trailPeriod}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <select
                          ref={ongoingTrailPeriodRef}
                          onChange={onInputChange}
                          value={ongoingClientTrailPeriod}
                          name="ongoingClientTrailPeriod"
                        >
                          {time_period.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.time}
                            </option>
                          ))}
                        </select>
                        {errors.ongoingClientTrailPeriod && (
                          <div className="text-danger small d-block">
                            {errors.ongoingClientTrailPeriod}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="shortDesc">
                    {createReffPartner?.shortDesc}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <textarea
                    placeholder="Short Description"
                    onChange={onInputChange}
                    value={shortDescription}
                    name="shortDescription"
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="image">{createReffPartner?.image}</label>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="input-group">
                  <div className="image-cropper-wrap">
                    <input
                      className="mb-1"
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    <div className="btn-crop mb-1">
                      {croppedAreaPixels && !croppedImage && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleCropClick}
                        >
                          {createReffPartner?.cropBtn}
                        </button>
                      )}
                    </div>
                    {imageSrc && !croppedImage && (
                      <div className="cropper-wrap">
                        <Cropper
                          image={imageSrc}
                          crop={crop}
                          zoom={zoom}
                          aspect={920 / 200}
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                        <div className="mt-2">
                          <input
                            id="range"
                            type="range"
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(e) =>
                              setZoom(parseFloat(e.target.value))
                            }
                          />
                        </div>
                      </div>
                    )}
                    {showCroppedImage && (
                      <div className="cropped-img-wrap">
                        <img src={showCroppedImage} alt="Cropped" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4 d-flex flex-column">
                <span className="text-danger">
                  {createReffPartner?.idealDimension}
                </span>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-5 d-flex d-sm-block justify-content-center justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions.Cancel}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading.createBtn}
                >
                  {loading.createBtn ? processing : buttonName.duplicate}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
